export const CHOOSE_PERIOD = '@@energyTab/choose_period'
export const CHOOSE_SLIDER_TAB = '@@energyTab/choose_slider_tab'
export const RESET_ENERGY_TAB = '@@energyTab/reset'

export const SYNC_ENERGIES = '@@energyTab/sync'

export const UPDATE_ENERGIES = '@@energyTab/update'
